import { render, staticRenderFns } from "./AboutWork.vue?vue&type=template&id=2b417840&scoped=true"
import script from "./AboutWork.vue?vue&type=script&lang=js"
export * from "./AboutWork.vue?vue&type=script&lang=js"
import style0 from "./AboutWork.vue?vue&type=style&index=0&id=2b417840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b417840",
  null
  
)

export default component.exports